import { ErrorEventCode } from '@hub/components/ErrorEventCode';
import { HelpLinkButton } from '@hub/components/HelpLinkButton';
import { m } from '@hub/messages';
import { Button, ErrorPage, ErrorPageActions, ErrorPageMessage, ErrorPageTitle } from '@platform/ui';
import { useGoBackOrHome } from '../hooks/useGoBackOrHome';
import { RouterPaths } from '../routePaths';
import { useRouteSearch } from '../useRouteSearch';

export function GenericErrorPage() {
  const { eventId, retryUrl } = useRouteSearch(RouterPaths.error);
  const goBackOrHome = useGoBackOrHome();

  return (
    <ErrorPage>
      <ErrorPageTitle>{m.commons_error_page_title()}</ErrorPageTitle>
      <ErrorPageMessage>{m.commons_error_page_message_generic()}</ErrorPageMessage>
      {eventId ? <ErrorEventCode eventId={eventId} /> : null}
      <ErrorPageActions>
        {retryUrl ? (
          <Button size="lg" asChild>
            <a href={retryUrl}>{m.commons_error_page_try_again()}</a>
          </Button>
        ) : null}
        <Button size="lg" variant={retryUrl ? 'outline' : 'default'} onClick={goBackOrHome}>
          {m.commons_error_page_back_to_home()}
        </Button>
        <HelpLinkButton />
      </ErrorPageActions>
    </ErrorPage>
  );
}
